import React from 'react';
import { motion } from 'framer-motion';
import { Key } from 'lucide-react';
const rules = [{
  title: 'Prioridad',
  desc: 'Por qué poner a Dios primero ordena tu agenda automáticamente y elimina la fricción.'
}, {
  title: 'Visión',
  desc: 'Cómo caminar por fe y tomar decisiones audaces cuando el mercado muestra escasez.'
}, {
  title: 'Obediencia',
  desc: 'La llave maestra que abre puertas de oportunidad que ningún hombre puede cerrar.'
}, {
  title: 'Humildad',
  desc: 'El secreto contraintuitivo para que Dios te exalte frente a tus competidores.'
}, {
  title: 'Servicio',
  desc: 'Cómo convertir tu negocio en un imán de éxito genuino resolviendo problemas reales.'
}];
export function SolutionSection() {
  return <section className="py-24 bg-cream-200 relative overflow-hidden" data-id="element-163">
      {/* Background Image subtle overlay */}
      <div className="absolute inset-0 opacity-[0.03] mix-blend-multiply pointer-events-none" data-id="element-164">
        <img src="https://cdn.magicpatterns.com/uploads/qrNL4uBFHBAhTNvDnm52cW/O2HmYuy4mhNQJhOQNAfIR.png" alt="Llave dorada" className="w-full h-full object-cover" data-id="element-165" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-cream-50 via-transparent to-cream-50 pointer-events-none" data-id="element-166" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-168">
          <div className="inline-flex items-center justify-center p-4 rounded-full bg-terra-500/10 mb-6" data-id="element-169">
            <Key className="w-8 h-8 text-terra-500" data-id="element-170" />
          </div>
          <h2 className="text-sm font-bold tracking-widest text-terra-500 uppercase mb-4" data-id="element-171">
            La Solución
          </h2>
          <h3 className="text-4xl md:text-5xl font-heading text-brown-900 mb-6 text-glow-gold" data-id="element-172">
            Las 5 Reglas de Dios
          </h3>
          <p className="text-lg text-brown-800 max-w-2xl mx-auto" data-id="element-173">
            Personas como Brian Tracy y John Maxwell han condensado décadas de
            sabiduría en este mapa estratégico de 5 pasos:
          </p>
        </motion.div>

        <div className="grid gap-6" data-id="element-174">
          {rules.map((rule, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative bg-white/60 backdrop-blur-sm border border-terra-500/10 p-6 md:p-8 rounded-2xl hover:border-terra-500/40 transition-all duration-300 hover:shadow-[0_0_30px_rgba(194,112,62,0.1)] overflow-hidden" data-id="element-175">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-terra-400 to-terra-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-176" />

              <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-start md:items-center" data-id="element-177">
                <div className="text-5xl font-heading font-black text-cream-50 text-stroke-terra opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-178">
                  0{index + 1}
                </div>
                <div data-id="element-179">
                  <h4 className="text-2xl font-heading text-terra-500 mb-2" data-id="element-180">
                    {rule.title}
                  </h4>
                  <p className="text-brown-800 text-lg leading-relaxed" data-id="element-181">
                    {rule.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Custom CSS for text stroke effect on numbers */}
      <style dangerouslySetInnerHTML={{
      __html: `
        .text-stroke-terra {
          -webkit-text-stroke: 1px #C2703E;
          color: transparent;
        }
      `
    }} data-id="element-182" />
    </section>;
}